import PropTypes from 'prop-types';
// material
import { Box } from '@material-ui/core';

// ----------------------------------------------------------------------

MiniLogo.propTypes = {
  sx: PropTypes.object
};

export default function MiniLogo({ sx }) {
  return (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <img src="/static/hub-crea/icon.png" alt="HUB CREA ADMIN" />
    </Box>
  );
}
